<template>
  <div>
    <div class="bg-white mb-4 px-20 py-12 rounded-lg relative">
      <div class="min-w-full">
        <div
          class="text-xl font-semibold text-gray-92 leading-8 mb-8"
          id="accountNotification"
        >
          通知設定
        </div>
        <div
          class="text-base font-semibold text-gray-92 leading-7"
          style="margin-bottom: 36px"
        >
          受信するメールにチェックを入れてください
        </div>
        <div class="mb-12">
          <div class="mb-6 text-gray-92">
            <label class="flex text-gray-92 mb-3">
              <input
                type="checkbox"
                name="notification2"
                class="mt-1 mr-4"
                :class="{
                  checked: state.notification.is_news_send_mail ? true : false,
                }"
                v-model="state.notification.is_news_send_mail"
              />

              <div>PRONIアイミツメンバーズからのニュースレターを受け取る</div>
            </label>
          </div>
        </div>
        <button
          type="submit"
          class="block mt-8 bg-secondary-main font-semibold text-white rounded hover:button focus:outline-none"
          style="width: 200px; height: 40px"
          @click="onSubmit()"
        >
          通知設定を変更
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, inject } from 'vue';
import axios from '@/utils/axiosAuth.js';

export default {
  props: {
    seller: Object,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const state = reactive({
      notification: {
        is_news_send_mail: props.seller.is_news_send_mail ? true : false,
      },
    });

    const onSubmit = async () => {
      const postData = {
        is_news_send_mail: state.notification.is_news_send_mail ? 1 : 0,
      };

      await axios
        .post(`/sellers/${props.seller.id}/notice/update`, postData)
        .then(() => {
          globalMethods.isToast('変更が完了しました。', { timeout: 3000 });
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    return {
      state,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
input[type='checkbox'] {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 14px;
  &::before {
    position: absolute;
    background: #fff;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    @apply border;
    border-radius: 3px;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    content: '';
    display: block;
    width: 5px;
    height: 9px;
    opacity: 0;
    transform: rotate(48deg);
  }
  &:hover::before {
    @apply border border-gray-92;
    box-shadow: 0px 0px 0px 2px rgba(52, 68, 100, 0.1);
  }
  &:checked::before {
    background: #28395c;
    border: 1px solid #28395c;
  }
  &:checked::after {
    opacity: 1;
  }
}
</style>
